export interface NicheData {
  slug: string;
  name: string;
  price: string;
  seoTitle: string;
  seoDescription: string;
  seoKeywords: string;
  heroHeadline: string;
  heroSubheadline: string;
  howWeWork: { step: string; title: string; description: string }[];
  whyUs: string[];
  telegramLink: string;
}

export const nichesData: NicheData[] = [
  {
    slug: 'avtosalon',
    name: 'Автосалон',
    price: '1 300–3 500 ₽',
    seoTitle: 'Заявки для автосалонов | Лидогенерация с оплатой за результат — AIGAM',
    seoDescription: 'Приводим целевые заявки для автосалонов из Telegram и соцсетей. Оплата только за квалифицированных клиентов, готовых к покупке автомобиля. Средняя цена заявки — от 1 300 ₽. Более 200 000 источников трафика.',
    seoKeywords: 'заявки автосалон, лидогенерация автосалон, клиенты для автосалона, покупка лидов авто, заявки на покупку авто',
    heroHeadline: 'Заявки для автосалонов с оплатой за результат',
    heroSubheadline: 'Находим людей, которые прямо сейчас ищут автомобиль. Вы платите только за квалифицированные заявки — клиентов, готовых к диалогу с менеджером.',
    howWeWork: [
      { step: '01', title: 'Мониторинг спроса', description: 'Анализируем 200 000+ Telegram-чатов, форумов и соцсетей. Находим людей, которые обсуждают покупку автомобиля, интересуются конкретными моделями, спрашивают советы по выбору.' },
      { step: '02', title: 'AI-квалификация', description: 'Наш ИИ вступает в диалог, уточняет бюджет, модель, сроки покупки, предпочтения по комплектации. Отсеивает любопытствующих — передаёт только целевых.' },
      { step: '03', title: 'Передача в CRM', description: 'Готовая заявка со всей историей переписки автоматически попадает в вашу CRM. Менеджеру остаётся только пригласить на тест-драйв и закрыть сделку.' },
    ],
    whyUs: [
      'Оплата только за квалифицированные заявки — никаких пустых лидов',
      'Средняя цена заявки 1 300–3 500 ₽ при среднем чеке авто от 1,5 млн ₽',
      'Первые заявки в течение 48 часов после запуска',
      'Интеграция с amoCRM, Bitrix24 и другими CRM',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'spectehnika',
    name: 'Спецтехника',
    price: '2 000–5 000 ₽',
    seoTitle: 'Заявки на спецтехнику | Лидогенерация для продажи спецтехники — AIGAM',
    seoDescription: 'Находим заказчиков спецтехники: экскаваторы, погрузчики, бульдозеры, краны. Оплата за квалифицированные заявки с подтверждённым бюджетом. Средняя цена — от 2 000 ₽. Работаем по всей России.',
    seoKeywords: 'заявки спецтехника, лидогенерация спецтехника, продажа спецтехники, клиенты на спецтехнику, заявки на покупку спецтехники',
    heroHeadline: 'Целевые заявки на спецтехнику с оплатой за результат',
    heroSubheadline: 'Приводим заказчиков, готовых к покупке спецтехники: экскаваторы, погрузчики, бульдозеры, краны и другая техника. Только реальные клиенты с подтверждённым интересом.',
    howWeWork: [
      { step: '01', title: 'Поиск целевой аудитории', description: 'Мониторим строительные и промышленные чаты, форумы подрядчиков. Находим компании и ИП, которые обсуждают покупку или аренду спецтехники.' },
      { step: '02', title: 'AI-квалификация', description: 'Уточняем тип техники, бюджет, регион, сроки. ИИ задаёт правильные вопросы и передаёт только подтверждённые заявки с полной информацией.' },
      { step: '03', title: 'Готовая заявка в CRM', description: 'Заявка попадает в вашу CRM с историей диалога. Менеджер получает клиента, который уже знает что хочет — осталось выставить КП.' },
    ],
    whyUs: [
      'Только целевые заявки от юрлиц и ИП с реальным бюджетом',
      'Цена заявки 2 000–5 000 ₽ при сделках на миллионы рублей',
      'Работаем по всей России и СНГ',
      'Персональный менеджер настраивает критерии под ваш бизнес',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'avto-s-auktsionov',
    name: 'Авто с аукционов',
    price: '1 500–3 000 ₽',
    seoTitle: 'Заявки на авто с аукционов | Лидогенерация для автоподбора — AIGAM',
    seoDescription: 'Приводим клиентов на авто с аукционов Японии, Кореи, США и Европы. Оплата за квалифицированные заявки. Находим людей, которые хотят заказать автоподбор. Средняя цена заявки — от 1 500 ₽.',
    seoKeywords: 'заявки авто с аукционов, лиды автоподбор, клиенты на авто из японии, заявки на автоподбор, лидогенерация авто с аукциона',
    heroHeadline: 'Клиенты на авто с аукционов — платите только за результат',
    heroSubheadline: 'Находим людей, которые хотят заказать авто из Японии, Кореи, США или Европы. Передаём только квалифицированные заявки с подтверждённым интересом и бюджетом.',
    howWeWork: [
      { step: '01', title: 'Поиск заинтересованных', description: 'Отслеживаем автофорумы, чаты JDM-энтузиастов, сообщества по автоподбору. Находим людей на стадии выбора и заказа авто с аукциона.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет страну, марку, бюджет, сроки. Выясняет готовность к предоплате и понимание процесса доставки. Передаём только горячие заявки.' },
      { step: '03', title: 'Заявка в работе', description: 'Вся переписка и профиль клиента — в вашей CRM. Менеджер подключается на финальном этапе и ведёт сделку от 150 000 ₽ и выше.' },
    ],
    whyUs: [
      'Тёплые клиенты, которые уже знают про аукционы и хотят заказать авто',
      'Цена заявки 1 500–3 000 ₽ при среднем чеке услуги 100 000–300 000 ₽',
      'Быстрый запуск — первые заявки через 48 часов',
      'Работаем с аукционами Японии, Кореи, США, Европы',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'avtoshkola',
    name: 'Автошкола',
    price: '800–2 000 ₽',
    seoTitle: 'Заявки для автошкол | Ученики на обучение с оплатой за результат — AIGAM',
    seoDescription: 'Приводим учеников для автошкол из Telegram и соцсетей. Оплата за квалифицированные заявки — людей, готовых записаться на обучение. Средняя цена ученика — от 800 ₽. Более 200 000 источников.',
    seoKeywords: 'заявки автошкола, ученики автошкола, лидогенерация автошкола, привлечение учеников, заявки на обучение вождению',
    heroHeadline: 'Ученики для автошколы с оплатой за результат',
    heroSubheadline: 'Находим людей, которые прямо сейчас ищут автошколу. Вы платите только за квалифицированные заявки — учеников, готовых записаться на обучение.',
    howWeWork: [
      { step: '01', title: 'Поиск учеников', description: 'Мониторим городские чаты, родительские сообщества, студенческие группы. Находим людей, которые спрашивают про автошколы, цены, отзывы.' },
      { step: '02', title: 'AI-консультация', description: 'ИИ рассказывает про категории, сроки, стоимость. Уточняет удобный район и график. Подогревает интерес и передаёт готового к записи ученика.' },
      { step: '03', title: 'Запись в группу', description: 'Заявка со всей информацией попадает администратору. Остаётся только подтвердить удобное время и оформить договор.' },
    ],
    whyUs: [
      'Ученики с подтверждённым намерением — не просто «посмотрю»',
      'Цена заявки 800–2 000 ₽ при стоимости обучения 30 000–60 000 ₽',
      'Первые ученики в течение 48 часов',
      'Настраиваем геотаргетинг по вашему городу',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'zastroyschiki',
    name: 'Застройщики',
    price: '3 000–10 000 ₽',
    seoTitle: 'Заявки для застройщиков | Покупатели квартир с оплатой за сделку — AIGAM',
    seoDescription: 'Приводим покупателей квартир для застройщиков из Telegram и соцсетей. Оплата за квалифицированные заявки с подтверждённым бюджетом. Средняя цена — от 3 000 ₽. Работаем по всей России.',
    seoKeywords: 'заявки застройщик, лидогенерация недвижимость, покупатели квартир, лиды на новостройки, заявки на покупку квартиры',
    heroHeadline: 'Покупатели квартир для застройщиков с оплатой за результат',
    heroSubheadline: 'Находим людей, которые выбирают новостройку. Вы платите только за квалифицированные заявки — покупателей с подтверждённым бюджетом и интересом к вашему ЖК.',
    howWeWork: [
      { step: '01', title: 'Поиск покупателей', description: 'Анализируем чаты новосёлов, ипотечные форумы, риелторские сообщества. Находим людей, обсуждающих покупку квартиры в новостройке.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет бюджет, район, количество комнат, цель покупки. Выясняет одобрена ли ипотека, сроки выхода на сделку и передаёт горячую заявку.' },
      { step: '03', title: 'Запись на просмотр', description: 'Квалифицированная заявка с полным профилем попадает в CRM. Менеджер назначает просмотр и ведёт сделку от 5 млн ₽.' },
    ],
    whyUs: [
      'Только платёжеспособные клиенты с подтверждённым бюджетом',
      'Цена заявки 3 000–10 000 ₽ при сделках на миллионы рублей',
      'Первые заявки через 48 часов после запуска',
      'Работаем с ЖК любого класса — от комфорт до премиум',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'stroitelstvo-domov',
    name: 'Строительство домов',
    price: '2 500–5 000 ₽',
    seoTitle: 'Заявки на строительство домов | Клиенты с оплатой за результат — AIGAM',
    seoDescription: 'Приводим заказчиков на строительство домов из Telegram и соцсетей. Оплата за квалифицированные заявки с подтверждённым бюджетом. Средняя цена — от 2 500 ₽. Ищем клиентов по всей России.',
    seoKeywords: 'заявки строительство домов, клиенты на стройку, лидогенерация строительство, заказчики домов, заявки на постройку дома',
    heroHeadline: 'Заказчики на строительство домов с оплатой за результат',
    heroSubheadline: 'Находим людей, которые хотят построить дом. Вы платите только за квалифицированные заявки — клиентов с участком и бюджетом на строительство.',
    howWeWork: [
      { step: '01', title: 'Поиск заказчиков', description: 'Мониторим форумы домостроения, чаты ИЖС, группы по строительству. Находим людей, которые обсуждают проекты, материалы, ищут подрядчиков.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет наличие участка, бюджет, площадь, технологию, сроки. Отсеивает «просто смотрю» — передаёт тех, кто реально планирует стройку.' },
      { step: '03', title: 'Выезд на замер', description: 'Готовая заявка с проектом и бюджетом в CRM. Менеджер назначает выезд и заключает договор от 2 млн ₽.' },
    ],
    whyUs: [
      'Заказчики с участком и подтверждённым бюджетом',
      'Цена заявки 2 500–5 000 ₽ при среднем чеке 5–15 млн ₽',
      'Первые заявки в течение 48 часов',
      'Работаем с любой технологией: каркас, кирпич, газобетон',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'proizvodstvo-ban',
    name: 'Производство бань',
    price: '1 000–2 000 ₽',
    seoTitle: 'Заявки на производство бань | Клиенты с оплатой за результат — AIGAM',
    seoDescription: 'Приводим заказчиков на строительство и производство бань. Оплата за квалифицированные заявки. Находим людей, готовых заказать баню под ключ. Средняя цена заявки — от 1 000 ₽.',
    seoKeywords: 'заявки производство бань, клиенты на бани, лидогенерация бани, заказчики бань, заявки на строительство бани',
    heroHeadline: 'Заказчики на бани с оплатой за результат',
    heroSubheadline: 'Находим людей, которые хотят заказать баню. Вы платите только за квалифицированные заявки — клиентов с участком и бюджетом.',
    howWeWork: [
      { step: '01', title: 'Поиск заказчиков', description: 'Мониторим дачные форумы, чаты домовладельцев, строительные сообщества. Находим людей, которые обсуждают строительство бани.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет размер, материал, бюджет, наличие участка. Выясняет нужна ли баня под ключ или только сруб — передаёт тёплую заявку.' },
      { step: '03', title: 'Расчёт сметы', description: 'Заявка с размерами, бюджетом и пожеланиями в CRM. Менеджер готовит КП и выезжает на замер.' },
    ],
    whyUs: [
      'Клиенты с участком и бюджетом на строительство',
      'Цена заявки 1 000–2 000 ₽ при среднем чеке 500 000–2 000 000 ₽',
      'Первые заявки в течение 48 часов',
      'Любые типы бань: бочка, сруб, каркасная, кирпичная',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'proizvodstvo-okon',
    name: 'Производство окон',
    price: '1 000–2 000 ₽',
    seoTitle: 'Заявки на окна ПВХ | Лидогенерация для оконных компаний — AIGAM',
    seoDescription: 'Приводим заказчиков на пластиковые окна. Оплата за квалифицированные заявки на остекление. Средняя цена — от 1 000 ₽. Находим клиентов на замену окон в квартирах и домах.',
    seoKeywords: 'заявки окна пвх, лидогенерация окон, клиенты на окна, заявки на остекление, продажа пластиковых окон',
    heroHeadline: 'Заказчики на окна с оплатой за результат',
    heroSubheadline: 'Находим людей, которые хотят заменить окна или застеклить балкон. Вы платите только за квалифицированные заявки — клиентов с размерами и бюджетом.',
    howWeWork: [
      { step: '01', title: 'Поиск клиентов', description: 'Мониторим городские чаты, форумы по ремонту, домовые сообщества. Находим людей, которые обсуждают замену окон или остекление.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет количество окон, тип профиля, бюджет, адрес. Выясняет срочность — передаёт горячую заявку на замер.' },
      { step: '03', title: 'Запись на замер', description: 'Заявка с размерами и контактами в CRM. Менеджер назначает замер и выставляет КП.' },
    ],
    whyUs: [
      'Клиенты с конкретным запросом: количество окон, адрес, бюджет',
      'Цена заявки 1 000–2 000 ₽ при среднем чеке 50 000–150 000 ₽',
      'Первые замеры в течение 48 часов',
      'ПВХ, алюминий, дерево — любые профили',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'proizvodstvo-kuhon',
    name: 'Производство кухонь',
    price: '2 000–3 500 ₽',
    seoTitle: 'Заявки на кухни на заказ | Лидогенерация для мебельных производств — AIGAM',
    seoDescription: 'Приводим заказчиков на кухни по индивидуальным размерам. Оплата за квалифицированные заявки. Находим клиентов, готовых заказать кухню. Средняя цена заявки — от 2 000 ₽.',
    seoKeywords: 'заявки кухни на заказ, лидогенерация кухни, клиенты на кухню, заявки на изготовление кухни, продажа кухонь',
    heroHeadline: 'Заказчики на кухни с оплатой за результат',
    heroSubheadline: 'Находим людей, которые хотят заказать кухню. Вы платите только за квалифицированные заявки — клиентов с размерами и бюджетом на изготовление.',
    howWeWork: [
      { step: '01', title: 'Поиск клиентов', description: 'Мониторим форумы по ремонту, дизайнерские чаты, сообщества новосёлов. Находим людей, которые обсуждают заказ кухни.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет размеры помещения, стиль, материал фасадов, бюджет. Выясняет сроки — передаёт горячую заявку на дизайн-проект.' },
      { step: '03', title: 'Выезд дизайнера', description: 'Заявка с размерами и пожеланиями в CRM. Менеджер назначает выезд дизайнера-замерщика и заключает договор от 200 000 ₽.' },
    ],
    whyUs: [
      'Клиенты с размерами кухни и подтверждённым бюджетом',
      'Цена заявки 2 000–3 500 ₽ при среднем чеке 200 000–500 000 ₽',
      'Первые заявки в течение 48 часов',
      'Любые материалы: МДФ, массив, пластик, эмаль',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'stomatologiya-implantatsiya',
    name: 'Стоматология: имплантация',
    price: '1 400–2 500 ₽',
    seoTitle: 'Заявки на имплантацию зубов | Пациенты для стоматологий — AIGAM',
    seoDescription: 'Приводим пациентов на имплантацию зубов. Оплата за квалифицированные заявки — людей, готовых записаться на консультацию. Средняя цена — от 1 400 ₽. Работаем по всей России.',
    seoKeywords: 'заявки имплантация зубов, пациенты стоматология, лидогенерация стоматология, заявки на имплантацию, клиенты для стоматологии',
    heroHeadline: 'Пациенты на имплантацию с оплатой за результат',
    heroSubheadline: 'Находим людей, которым нужна имплантация зубов. Вы платите только за квалифицированные заявки — пациентов, готовых на консультацию.',
    howWeWork: [
      { step: '01', title: 'Поиск пациентов', description: 'Мониторим медицинские форумы, городские чаты, сообщества по здоровью. Находим людей, которые обсуждают имплантацию, спрашивают цены и клиники.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет количество зубов, бюджет, сроки, готовность к процедуре. Отвечает на базовые вопросы и передаёт тёплую заявку.' },
      { step: '03', title: 'Запись на консультацию', description: 'Пациент с историей диалога попадает в CRM. Администратор назначает удобное время — пациент приходит на консультацию от 30 000 ₽.' },
    ],
    whyUs: [
      'Пациенты с подтверждённым интересом к имплантации',
      'Цена заявки 1 400–2 500 ₽ при среднем чеке 150 000–500 000 ₽',
      'Первые пациенты через 48 часов',
      'Работаем с клиниками любого уровня',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'fitnes-zal',
    name: 'Фитнес-зал',
    price: '900–1 400 ₽',
    seoTitle: 'Заявки для фитнес-клубов | Клиенты с оплатой за результат — AIGAM',
    seoDescription: 'Приводим клиентов в фитнес-клубы и тренажёрные залы. Оплата за квалифицированные заявки — людей, готовых купить абонемент. Средняя цена — от 900 ₽. Находим клиентов в вашем городе.',
    seoKeywords: 'заявки фитнес зал, клиенты фитнес клуб, лидогенерация фитнес, заявки на абонемент, привлечение в фитнес',
    heroHeadline: 'Клиенты в фитнес-клуб с оплатой за результат',
    heroSubheadline: 'Находим людей, которые хотят начать заниматься. Вы платите только за квалифицированные заявки — клиентов, готовых купить абонемент.',
    howWeWork: [
      { step: '01', title: 'Поиск клиентов', description: 'Мониторим городские чаты, спортивные сообщества, группы по похудению. Находим людей, которые ищут зал рядом с домом или работой.' },
      { step: '02', title: 'AI-консультация', description: 'ИИ рассказывает о клубе, тренерах, программах. Уточняет цели и удобное время. Передаёт заявку на пробное занятие или абонемент.' },
      { step: '03', title: 'Продажа абонемента', description: 'Заявка с контактами попадает в CRM. Менеджер приглашает на бесплатную тренировку и продаёт абонемент от 15 000 ₽.' },
    ],
    whyUs: [
      'Люди с реальным желанием заниматься — не просто «посмотрю»',
      'Цена заявки 900–1 400 ₽ при LTV клиента 30 000–80 000 ₽',
      'Первые клиенты через 48 часов',
      'Геотаргетинг по вашему городу и району',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'yuridicheskie-uslugi-bfl',
    name: 'Юридические услуги, БФЛ',
    price: '1 000–1 900 ₽',
    seoTitle: 'Заявки на банкротство физлиц | Лидогенерация для юристов — AIGAM',
    seoDescription: 'Приводим клиентов на банкротство физических лиц и юридические услуги. Оплата за квалифицированные заявки. Средняя цена — от 1 000 ₽. Находим должников, готовых к процедуре.',
    seoKeywords: 'заявки банкротство физлиц, лиды юристы, клиенты на банкротство, заявки юридические услуги, лидогенерация банкротство',
    heroHeadline: 'Клиенты на банкротство физлиц с оплатой за результат',
    heroSubheadline: 'Находим людей, которым нужно банкротство. Вы платите только за квалифицированные заявки — должников, готовых начать процедуру.',
    howWeWork: [
      { step: '01', title: 'Поиск должников', description: 'Мониторим форумы должников, юридические чаты, сообщества по финансам. Находим людей с кредитами, которые обсуждают банкротство.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет сумму долга, количество кредиторов, регион. Проводит первичную консультацию и передаёт тёплую заявку.' },
      { step: '03', title: 'Консультация юриста', description: 'Заявка с суммой долга и профилем должника в CRM. Юрист назначает консультацию и заключает договор от 100 000 ₽.' },
    ],
    whyUs: [
      'Должники с подтверждённой суммой и готовностью к процедуре',
      'Цена заявки 1 000–1 900 ₽ при стоимости услуги 100 000–200 000 ₽',
      'Первые заявки в течение 48 часов',
      'Работаем по всей России',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'obrazovanie',
    name: 'Образование',
    price: '700–1 800 ₽',
    seoTitle: 'Заявки на обучение | Студенты для образовательных проектов — AIGAM',
    seoDescription: 'Приводим студентов на курсы и образовательные программы. Оплата за квалифицированные заявки. Средняя цена — от 700 ₽. Находим людей, готовых оплатить обучение.',
    seoKeywords: 'заявки обучение, студенты курсы, лидогенерация образование, заявки на курсы, привлечение студентов',
    heroHeadline: 'Студенты на обучение с оплатой за результат',
    heroSubheadline: 'Находим людей, которые хотят учиться. Вы платите только за квалифицированные заявки — студентов, готовых оплатить курс.',
    howWeWork: [
      { step: '01', title: 'Поиск студентов', description: 'Мониторим образовательные чаты, карьерные сообщества, группы по профессиям. Находим людей, которые обсуждают курсы и обучение.' },
      { step: '02', title: 'AI-консультация', description: 'ИИ рассказывает о программе, отвечает на вопросы, уточняет цели и уровень подготовки. Передаёт заявку на бесплатный урок или консультацию.' },
      { step: '03', title: 'Оплата курса', description: 'Заявка с профилем студента в CRM. Менеджер проводит вводный урок и продаёт курс от 30 000 ₽.' },
    ],
    whyUs: [
      'Мотивированные студенты с конкретным запросом',
      'Цена заявки 700–1 800 ₽ при среднем чеке 30 000–150 000 ₽',
      'Первые заявки в течение 48 часов',
      'Любые направления: IT, маркетинг, дизайн, языки',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'turizm',
    name: 'Туризм',
    price: '900–2 000 ₽',
    seoTitle: 'Заявки на туры | Лидогенерация для турагентств — AIGAM',
    seoDescription: 'Приводим клиентов на покупку туров. Оплата за квалифицированные заявки. Средняя цена — от 900 ₽. Находим людей, которые планируют отпуск и ищут тур.',
    seoKeywords: 'заявки туры, клиенты турагентство, лидогенерация туризм, заявки на путёвки, продажа туров',
    heroHeadline: 'Клиенты на туры с оплатой за результат',
    heroSubheadline: 'Находим людей, которые планируют отпуск. Вы платите только за квалифицированные заявки — клиентов, готовых подобрать и купить тур.',
    howWeWork: [
      { step: '01', title: 'Поиск путешественников', description: 'Мониторим тревел-чаты, форумы путешественников, городские сообщества. Находим людей, которые обсуждают направления, отели, цены на туры.' },
      { step: '02', title: 'AI-консультация', description: 'ИИ уточняет направление, даты, бюджет, количество человек. Подбирает варианты и передаёт горячую заявку.' },
      { step: '03', title: 'Подбор тура', description: 'Заявка с пожеланиями и бюджетом в CRM. Менеджер подбирает тур и оформляет бронь от 100 000 ₽.' },
    ],
    whyUs: [
      'Клиенты с конкретными датами, направлением и бюджетом',
      'Цена заявки 900–2 000 ₽ при среднем чеке тура 100 000–300 000 ₽',
      'Первые заявки в течение 48 часов',
      'Массовые и премиум-направления',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'onlayn-shkoly',
    name: 'Онлайн школы',
    price: '1 000–5 000 ₽',
    seoTitle: 'Заявки для онлайн-школ | Ученики с оплатой за результат — AIGAM',
    seoDescription: 'Приводим учеников в онлайн-школы из Telegram и соцсетей. Оплата за квалифицированные заявки. Находим людей, готовых оплатить онлайн-курс. Средняя цена — от 1 000 ₽.',
    seoKeywords: 'заявки онлайн школа, ученики онлайн курсы, лидогенерация онлайн школа, заявки на онлайн обучение, привлечение учеников онлайн',
    heroHeadline: 'Ученики для онлайн-школы с оплатой за результат',
    heroSubheadline: 'Находим людей, которые хотят учиться онлайн. Вы платите только за квалифицированные заявки — учеников, готовых купить курс.',
    howWeWork: [
      { step: '01', title: 'Поиск учеников', description: 'Анализируем Telegram-каналы по образованию, карьерные чаты, нишевые сообщества. Находим людей, ищущих курсы в вашей тематике.' },
      { step: '02', title: 'AI-прогрев', description: 'ИИ рассказывает о программе, кейсах учеников, отвечает на возражения. Квалифицирует по бюджету и передаёт тёплого лида.' },
      { step: '03', title: 'Продажа курса', description: 'Готовый к покупке ученик в CRM. Менеджер закрывает сделку и оформляет доступ к курсу от 30 000 ₽.' },
    ],
    whyUs: [
      'Ученики, прогретые AI-диалогом — не нужно тратить время на холодные касания',
      'Цена заявки 1 000–5 000 ₽ при среднем чеке 30 000–200 000 ₽',
      'Масштабирование от 10 до 500+ заявок в месяц',
      'Любые ниши: IT, маркетинг, финансы, здоровье, хобби',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
  {
    slug: 'b2b',
    name: 'B2B',
    price: '2 000–10 000 ₽',
    seoTitle: 'B2B заявки | Лидогенерация для корпоративных продаж — AIGAM',
    seoDescription: 'Приводим B2B-клиентов из Telegram и соцсетей. Оплата за квалифицированные заявки от юрлиц. Находим ЛПР с подтверждённым бюджетом. Средняя цена — от 2 000 ₽. Работаем со сложными нишами.',
    seoKeywords: 'b2b заявки, лидогенерация b2b, корпоративные клиенты, b2b лиды, заявки для бизнеса',
    heroHeadline: 'B2B-заявки с оплатой за результат',
    heroSubheadline: 'Находим корпоративных клиентов для вашего бизнеса. Вы платите только за квалифицированные заявки — ЛПР с подтверждённым бюджетом и потребностью.',
    howWeWork: [
      { step: '01', title: 'Поиск ЛПР', description: 'Мониторим бизнес-чаты, отраслевые форумы, предпринимательские сообщества. Находим владельцев и руководителей с конкретными бизнес-запросами.' },
      { step: '02', title: 'AI-квалификация', description: 'ИИ уточняет компанию, должность, бюджет, потребность, сроки. Отсеивает микробизнес и нецелевых — передаёт только ЛПР с реальным спросом.' },
      { step: '03', title: 'Передача в отдел продаж', description: 'Квалифицированная заявка с профилем компании и контактом ЛПР в CRM. Менеджер назначает звонок и ведёт сделку от 500 000 ₽.' },
    ],
    whyUs: [
      'Только ЛПР — владельцы и руководители с бюджетом',
      'Цена заявки 2 000–10 000 ₽ при среднем чеке B2B-сделки от 500 000 ₽',
      'Первые заявки в течение 48 часов',
      'Любые B2B-ниши: IT, оборудование, услуги, производство',
    ],
    telegramLink: 'https://t.me/anna_aigam',
  },
];